import { Component, OnInit, Input, ContentChildren, QueryList } from '@angular/core';
import { CdAccordionPanelTplComponent } from '../cd-accordion-panel-tpl/cd-accordion-panel-tpl.component';
import { CdsIconConfig } from '@cds/ng-core/icon';
import { CdsProgressModule } from '@cds/ng-web-components/progress';
import { NoResultFoundComponent } from '../../../shared/no-result-found/no-result-found.component';

@Component({
  selector: 'app-cd-accordion-tpl',
  templateUrl: './cd-accordion-tpl.component.html',
  styleUrls: ['./cd-accordion-tpl.component.scss'],
  imports: [CdsProgressModule, NoResultFoundComponent],
})
export class CdAccordionTplComponent implements OnInit {
  @ContentChildren(CdAccordionPanelTplComponent)
  cols?: QueryList<CdAccordionPanelTplComponent>;
  @Input() noTopLine = false;
  @Input() noResultMsg?: string;
  @Input() progress = false;

  notfoundConfig: CdsIconConfig = { color: '#8e90a2', size: 'md' };

  constructor() {}

  ngOnInit(): void {}
}
